module.exports = __webpack_public_path__ + "img/20.b93f175d.png";